import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { ChevronRight, Minus, Plus, SaveIcon } from 'lucide-react';
import { useMsal } from "@azure/msal-react";
import DatePicker from "react-datepicker";
import Select, { SingleValue } from 'react-select';
import { loginRequest } from "../authConfig";
import AppCarousel from '../components/AppCarousel';
import { AppData } from 'models/AppData';
import { AppApiResponse } from 'models/AppApiResponse';
import { Feature } from 'models/Feature';
import { getRxAppData, setRxAppData } from '../redux/appCenterSlice';
import { initializeAuth, saveAppDetails, axiosFetch } from "services/apiService";
import "react-datepicker/dist/react-datepicker.css";

const API_URL = process.env.REACT_APP_API_URL || "";
interface Option {
  value: string;
  label: string;
}
interface Categories {
  id: string;
  name: string;
}

const featuresSelect = {
  control: (base: any) => ({
    ...base,
    height: 30,
    minHeight: 30,
    width: 100,
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 8px',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    padding: '0px 0px',
    height: 30,
    width: 28,
  }),
};

const categorySelect = {
  control: (base: any) => ({
    ...base,
    height: 30,
    minHeight: 30,
    width: 100,
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 8px',
    textAlign: 'left',
  }),
  dropdownIndicator: (defaultStyles: any) => ({
    ...defaultStyles,
    '& svg': { display: 'none' },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
};

const AppCenter: React.FC = () => {
  const dispatch = useDispatch();
  const [inputKey, setInputKey] = useState(0);
//  const [showDeleteConfirm, setShowDeleteConfirm] = useState({  show: false,  id: -1 });
  const [outputKey, setOutputKey] = useState(0);
  const [featureKey, setFeatureKey] = useState(0);
  const [editFeatureIndex, setEditFeatureIndex] = useState(-1);
  const [inputContent, setInputContent] = useState('');
  const [outputContent, setOutputContent] = useState('');
  const [featureContent, setFeatureContent] = useState('');
  const [releaseNotes, setReleaseNotes] = useState('');
  const [releaseNotesChanged, setReleaseNotesChanged] = useState(false);
//  const [releaseDateActive, setReleaseDateActive] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const rxAppData = useSelector(getRxAppData);
  const { appname } = useParams<{ appname: string }>();
  
  const { instance, accounts } = useMsal();
  const [appData, setAppData] = useState<AppData | null>(null);
  const [apiResponse, setApiResponse] = useState<AppApiResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [releaseDate, setReleaseDate] = useState(new Date());
  const [versions, setVersions] = useState<Option[]>([]);
  const [categories, setCategories] = useState<Categories[]>([]);

  const [selectedCategory, setSelectedCategory] = useState<Option | null>();
  const [selectedStatus, setSelectedStatus] = useState<Option | null>();
  const [selectedVersion, setSelectedVersion] = useState('');
//  const [showModal, setShowModal] = useState(false);


// type FunctionName = 'delInputOutput' | 'delFeature';
// type FunctionMapType = Record<FunctionName, () => void>;
// const functionMap: FunctionMapType = {
//   delFeature: delFeature,
//   delInputOutput: delInputOutput,
// };

  // const handleClose = () => setShowModal(false);
  // const handleOk = (funcName: FunctionName, id: number) => {
  //   setShowModal(false);
  //   const execFunc = functionMap[funcName];
  //   if (execFunc && typeof execFunc === 'function') {
  //     execFunc(id); 
  //   } else {
  //     console.error(`Function ${execFunc} not found.`);
  //   }
  // };

  // const handleDelete = (id: number) => {
  //   setShowDeleteConfirm({
  //     show: true,
  //     id,
  //   });
  // };

  const loadCategories = async () => {
    const result = await axiosFetch.get(`${API_URL}/engineering/categories`);
    setCategories(result.data);
  };

    
  const categoryOptions = categories.map(cat => {return {value: cat.id, label: cat.name}});
  const featureStatus: Array<Option> = [
    { value: 'Included', label: 'Included' },
    { value: 'In Queue', label: 'In Queue' },
    { value: 'Needs Discussion', label: 'Needs Discussion' }];

  const postInputOutput = async(id: number, type: string, description: string) => {
    console.log('=======> postInputOutput');
    let dataIO = [...rxAppData.inputOutputs];

    if (id === 0) {
      if (description === '')
      {
        return;
      }
      const newIO = {applicationId: rxAppData.id, ioType: type, description: description, status: true};
      dataIO.push(newIO);
    }
    else {
      const ioElem = dataIO.find(d => d.id === id);
      if (ioElem.description === description)
      {
        return;
      }
      const newIO = {id: id, applicationId: rxAppData.id, ioType: type, description: description, status: true};
      const ioIdx = dataIO.findIndex(d => d.id === id);
      if (ioIdx !== -1) {
        dataIO.splice(ioIdx, 1)
      }
      dataIO.push(newIO);
      dataIO.sort((a,b) => a.id - b.id);
    }
    const appData = { ...rxAppData, inputOutputs: dataIO };
    saveAppDetails(appData);
    if (type === 'Input')
      setInputKey(k => k + 1);
    else
      setOutputKey(k => k + 1);
    const transformedData = transformApiResponse(appData);
    await initializeAuth(instance, accounts);
    setAppData(transformedData);
    dispatch(setRxAppData(appData));
  }

  const postFeature = async(id: number, description: string, status: string, version: string) => {
    console.log('=======> postFeature');
    let lstFeatures = [...rxAppData.features];

    if (id === 0) {
      if (description === '')
      {
        return;
      }
      const newFeature = {applicationId: rxAppData.id, description: description, status: status, version: version};
      lstFeatures.push(newFeature);
    }
    else {
      const ioElem = lstFeatures.find(d => d.id === id);
      if (ioElem.description === description && ioElem.status === status && ioElem.version === version)
      {
        return;
      }
      const newFeature = {id: id, applicationId: rxAppData.id, description: description, status: status, version: version};
      const featureIdx = lstFeatures.findIndex(d => d.id === id);
      if (featureIdx !== -1) {
        lstFeatures.splice(featureIdx, 1)
      }
      lstFeatures.push(newFeature);
      lstFeatures.sort((a,b) => a.id - b.id);
    }
    const appData = { ...rxAppData, features: lstFeatures };
    await initializeAuth(instance, accounts);
    await saveAppDetails(appData);
    setFeatureKey(k => k + 1);
    fetchAppData();
  }

  const delInputOutput = async(id: number) => {
    console.log('=======> delInputOutput');
    const result = await window.confirm('Are you sure you want to delete this item?'); 
    if (!result) {
      return;
    }
//    setShowModal(true);
    let dataIO = [...rxAppData.inputOutputs];
    const ioElem = dataIO.findIndex(d => d.id === id);
    if (ioElem !== -1) {
      dataIO.splice(ioElem, 1)
    }
    else {
      return;
    }
    const appData = { ...rxAppData, inputOutputs: dataIO };
    await initializeAuth(instance, accounts);
    saveAppDetails(appData);
    const transformedData = transformApiResponse(appData);
    setAppData(transformedData);
    dispatch(setRxAppData(appData));
  }

  const handleReleaseNotes = (notes: string) => {
    setReleaseNotesChanged(notes !== rxAppData.releaseNotes);
    setReleaseNotes(notes);
  }

  const handleCreatedBy = async(createdBy: string) => {
    console.log('=======> handleCreatedBy');
    const appData = { ...rxAppData, developedBy: createdBy };
    await initializeAuth(instance, accounts);
    saveAppDetails(appData);
  }

  // const handleCreationDate = async(releaseDate: string) => {
  //   //TODO two saveAppDetails with Createtion Date
  //   console.log('=======> handleCreationDate');
  //   const appData = { ...rxAppData, releaseDate: releaseDate };
  //   await initializeAuth(instance, accounts);
  //   saveAppDetails(appData);
  // }

  const postCreationDate = async(releaseDate: Date | null) => {
    console.log('=======> postCreationDate');
    const appData = { ...rxAppData, releaseDate: releaseDate };
    await initializeAuth(instance, accounts);
    saveAppDetails(appData);
  }

  const postReleaseNotes = async() => {
    console.log('=======> postReleaseNotes');
    const appData = { ...rxAppData, releaseNotes: releaseNotes };
    await initializeAuth(instance, accounts);
    saveAppDetails(appData);
    setReleaseNotesChanged(false);
  }

  const postFeatureDescription = (index: number, description: string): void => {
    const realIdx = appData!.features!.length - (index + 1);
    const feature = appData?.features[realIdx];
    if (!feature || !description)
      return;

    postFeature(feature.id, description, feature.status, feature.version);
  }

  const postFeatureVersion = (index: number, version: string): void => {
    const realIdx = appData!.features!.length - (index + 1);
    const feature = appData?.features[realIdx];
    if (!feature || !version)
      return;

    postFeature(feature.id, feature.description, feature.status, version);
  }

  const delFeature = async(index: number) => {
    const result = await window.confirm('Are you sure you want to delete this item?'); 
    if (!result) {
      return;
    }
    const realIdx = appData!.features!.length - (index + 1);
    let features = [...rxAppData.features];
    features.splice(realIdx, 1);

    const apps = { ...rxAppData, features: features };
    await initializeAuth(instance, accounts);
    await saveAppDetails(apps);
    const transformedData = transformApiResponse(apps);
    setAppData(transformedData);
    dispatch(setRxAppData(apps));
  }

  const handleSelectedStatus = (index: number, option: SingleValue<Option>): void => {
    console.log('=======> handleSelectedStatus');
    setEditFeatureIndex(-1);
    if (index < 0)
    {
      setSelectedStatus(option);
    }
    else {
      const realIdx = appData!.features!.length - (index + 1);
      const feature = appData?.features[realIdx];
      if (!feature || !option)
        return;

      postFeature(feature.id, feature.description, option.value, feature.version);
    }
  }

   const handleCategorySelect = (option: SingleValue<Option>): void => {
    console.log('=======> handleCategorySelect');
    setSelectedCategory(option);
    const appData = { ...rxAppData, categories: option ? [option.label] : [] };
    initializeAuth(instance, accounts);
    saveAppDetails(appData);
  };

  const transformApiResponse = (data: AppApiResponse): AppData => {
    const inputs = data.inputOutputs
      .filter(io => io.ioType === 'Input')
      .map(io => {return {id: io.id, description: io.description}});
    
    const outputs = data.inputOutputs
      .filter(io => io.ioType === 'Output')
      .map(io => {return {id: io.id, description: io.description}});
    
    const featureCount = data.features.length > 3 ? 3 : data.features.length;
    const lastFeatures = data.features.slice(-1 * featureCount);

    const allVersions = data.features.map(f => f.version);
    allVersions.forEach(v => {
      if (!versions.some(ver => ver.value === v))
      {
        setVersions([...versions, {value: v, label: v}]);
      }
    });


    // Creación de fecha formateada
    const releaseDate = new Date(data.releaseDate);
    const formattedDate = `${releaseDate.toLocaleString('default', { month: 'short' })} ${releaseDate.getDate()}, ${releaseDate.getFullYear()}`;
    setReleaseDate(releaseDate);

    return {
      input: inputs,
      output: outputs,
      lastAddedFeatures: lastFeatures,
      features: data.features,
      releaseNotes: data.releaseNotes,
      tutorials: data.tutorials,
      documentation: data.documentation,
      support: data.support,
      faqs: data.faqs,
      systemRequirements: {
        text: data.systemRequirements.framework,
        link: data.systemRequirements.frameworkURL
      },
      additionalInfo: {
        creator: data.developedBy,
        creationDate: formattedDate,
        size: data.size,
        filesize: data.size,
        language: data.languages.join(', '),
        version: data.version
      },
      relatedResources: [
        { name: 'Tutorials', link: '/tutorials/' + data.name },
        { name: 'Documentation', link: data.url },
        { name: 'Support', link: '/support/' + data.name },
        { name: 'FAQs', link: '/faqs/' + data.name },
      ],
      screenshots: data.sampleImages
    };
  };

  const fetchAppData = async () => {
    console.log('=======> fetchAppData');
    if (!appname) {
      setError('App name is required');
      return;
    }
    
    try {
      setIsLoading(true);
      
      // Acquire token silently
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });

      const accessToken = response.accessToken;

      // Fetch app information using the appname from URL parameter
      const apiResponse = await fetch(`${API_URL}/engineering/appcenter/info?appName=${encodeURIComponent(appname)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!apiResponse.ok) {
        throw new Error(`HTTP error! Status: ${apiResponse.status}`);
      }

      const data = await apiResponse.json();
      console.log('=======> fetchAppData data read');
      setApiResponse(data);
      
      const transformedData = transformApiResponse(data);
      setAppData(transformedData);
      dispatch(setRxAppData(data));

      setError(null);
    } catch (err) {
      console.error('Error fetching app data:', err);
      setError('Failed to load application data. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
     console.log('=======> useEffect');
    if (accounts && accounts.length > 0 && appname !== rxAppData.name) {
      setIsFetching(true);
      fetchAppData();
      loadCategories();
      setIsFetching(false);
    }
    else if(accounts && accounts.length > 0 && appname === rxAppData.name)
    {
        const transformedData = transformApiResponse(rxAppData);
        setAppData(transformedData);
    }
  }, [accounts, instance, appname, rxAppData]);

  return (
    <div className="pb-10 bg-gray-50 font-roboto">
      {/* <ModalDialog
          title={`Confirm Delete`}
          children={null}
          showModal={showModal}
          handleClose={handleClose}
          handleOk={handleOk}
          okLabel="Confirm"
          closeLabel="Cancel"
          isOk={true}
          ></ModalDialog>       */}
      {/* Header */}
      <div className="relative rounded-lg overflow-hidden mb-6" style={{ maxHeight: '300px' }}>
        <img src="/headerBlue.svg" alt="Header background" className="absolute inset-0 w-full h-full object-cover" />
        <div className="relative z-10 p-12 pl-16 text-left">
          <h2 className="text-5xl font-roboto text-white text-left">{apiResponse?.name}</h2>
          {apiResponse?.categories && (
            <div className="flex flex-wrap gap-2 mt-4">
              {apiResponse.categories.map((cat, index) => (
                <span key={index} className="bg-white text-[#1D5176] px-2 py-0.5 rounded-md text-xs font-roboto inline-block">
                  {cat.name}
                </span>
              ))}
              {apiResponse?.downloadCount && (
                <span className="text-white text-sm ml-2 inline-block">{apiResponse.downloadCount} downloads</span>
              )}
            </div>
          )}
        
          <div className="relative group">
          <p className="text-white text-base mt-4 max-w-xl text-left font-roboto line-clamp-2" 
            title={apiResponse?.description}>
            {apiResponse?.description}
          </p>
          </div>
          
          {apiResponse && (
            <a href={apiResponse.url} target="_blank" rel="noopener noreferrer">
              <button className="bg-[#1D5176] text-[#F1F7FD] px-6 py-2 rounded font-roboto hover:bg-[#2A6690] transition-colors mt-8">
                {apiResponse.applicationType === 'Desktop' ? 'Download Installer': "Go to Application"}
              </button>
            </a>
          )}
        </div>
      </div>
      
      {/* Loading/Error states */}
      {isLoading && (
        <div className="text-center py-8">
          <p>Loading application data...</p>
        </div>
      )}
      
      {error && (
        <div className="text-center py-8">
          <p className="text-red-500">{error}</p>
        </div>
      )}
      
      {/* Updated Carousel Component */}
      {appData && (
        <div className="container mx-auto px-6 mb-6">
          <AppCarousel screenshots={appData.screenshots || []} />
        </div>
      )}
      
      {appData && (
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {/* Left Column (3/4 width) */}
            <div className="col-span-3 space-y-6">
              {/* Input/Output Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                  <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Input</h3>
                  <div className="p-1">
                    <ul className="pl-1 text-left">
                      {appData.input.map((item, index: number) => (
                        <li key={index} className="text-sm flex ul-io">
                          <span contentEditable="plaintext-only" onBlur={(e) => postInputOutput(item.id, 'Input', e.target.innerHTML)} className='width-100 p-1 mr-1' dangerouslySetInnerHTML={{__html: item.description}} />
                          <button onClick={() => delInputOutput(item.id)} className="bg-[#5e7c93] text-white p-1 h-6 w-6 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80">
                            <Minus size={20} />
                          </button>
                        </li>
                      ))}
                      <li className="text-sm flex ul-io">
                        <span key={inputKey} contentEditable="plaintext-only" onBlur={(e) => setInputContent(e.target.innerHTML)} className='width-100 editable p-1 mr-1' />
                        <button className="bg-[#5e7c93] text-white p-1 h-6 w-6 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80" onClick={(e) => postInputOutput(0, 'Input', inputContent)}>
                          <Plus size={20} />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                  <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Output</h3>
                  <div className="p-1">
                    <ul className="pl-1 text-left">
                      {appData.output.map((item, index: number) => (
                        <li key={index} className="text-sm flex ul-io">
                          <span contentEditable="plaintext-only" onBlur={(e) => postInputOutput(item.id, 'Output', e.target.innerHTML)} className='width-100 p-1 mr-1' dangerouslySetInnerHTML={{__html: item.description}} />
                          <button onClick={() => delInputOutput(item.id)} className="bg-[#5e7c93] text-white p-1 h-6 w-6 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80">
                            <Minus size={20} />
                          </button>
                        </li>
                      ))}
                      <li className="text-sm flex ul-io">
                        <span key={outputKey} contentEditable="plaintext-only" onBlur={(e) => setOutputContent(e.target.innerHTML)} className='width-100 editable p-1 mr-1' />
                        <button className="bg-[#5e7c93] text-white p-1 h-6 w-6 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80" onClick={(e) => postInputOutput(0, 'Output', outputContent)}>
                          <Plus size={20} />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Last added features</h3>
                <div className="p-4">
                  <p className="font-medium text-sm">Current Version: V{appData.additionalInfo.version}</p>
                  <div className="ml-4 mt-2 space-y-2">
                  {appData.lastAddedFeatures &&
                    appData.lastAddedFeatures.map((feature: Feature) => (
                     <div className="flex gap-2 text-sm">
                      <span>{feature.version}.</span>
                      <span>{feature.description}</span>
                    </div>
                    ))
                  }
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium text-center">Features</h3>
                <div className="p-0">
                  <div className="p-1">
                    <table className="w-full text-sm border-collapse">
                      <colgroup>
                        <col className="col1-width" />
                        <col className="col2-width" />
                        <col className="col3-width" />
                        <col className="col4-width" />
                        <col className="col5-width" />
                      </colgroup>
                      <tbody>
                        <tr className='h-8'>
                          <td>
                          </td>
                          <td valign='top' className='text-left py-3 px-4'>
                            <span key={featureKey} contentEditable="plaintext-only" onBlur={(e) => setFeatureContent(e.target.innerHTML)} className='display-block editable width-100 p-1 mr-1' />
                          </td>
                          <td>
                            <Select options={featureStatus} value={selectedStatus} onChange={e => handleSelectedStatus(-1, e)} placeholder="--" styles={featuresSelect} components={{IndicatorSeparator: () => null}} />
                          </td>
                          <td className='px-2'>
                            <span key={featureKey} contentEditable="plaintext-only" onBlur={(e) => setSelectedVersion(e.target.innerHTML)}  className='display-block editable width-100 p-1 mr-1' />
                          </td>
                          <td>
                            <button className="bg-[#5e7c93] text-white p-1 h-6 w-6 mt-1 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80" onClick={(e) => postFeature(0, featureContent, selectedStatus ? selectedStatus.value : '', selectedVersion)}>
                              <Plus size={20} />
                            </button>
                          </td>
                        </tr>
                        {appData.features.slice(0).reverse().map((feature: Feature, index: number) => (
                          <tr key={index} className="border-b border-gray-200 last:border-b-0">
                            <td className="py-3 px-4 text-center text-gray-600 w-12">{feature.id}</td>
                            <td className="py-3 px-4 text-left">
                              <span key={index} contentEditable="plaintext-only" onBlur={(e) => postFeatureDescription(index, e.target.innerHTML)}  dangerouslySetInnerHTML={{__html: feature.description}} className='width-100 display-block p-1 mr-1' />
                            </td>
                            <td className="py-3 px-4 whitespace-nowrap text-right w-32" onClick={e => setEditFeatureIndex(index)}>
                              <span className={
                                feature.status === "Included" ? "text-green-600" : 
                                feature.status === "In Queue" ? "text-yellow-600" : 
                                feature.status === "Needs Discussion" ? "text-red-600" : ""
                              }>
                              {editFeatureIndex !== index && feature.status }
                              {editFeatureIndex === index &&
                                <Select options={featureStatus} value={featureStatus.find(f => f.value === feature.status)} onChange={e => handleSelectedStatus(index, e)} placeholder="--" styles={featuresSelect} components={{IndicatorSeparator: () => null}} />
                              }
                              </span>
                            </td>
                            <td className="py-3 px-4 text-right text-yellow-700 w-20">
                              <span key={index} contentEditable="plaintext-only" onBlur={(e) => postFeatureVersion(index, e.target.innerHTML)}  dangerouslySetInnerHTML={{__html: feature.version}} className='width-100 p-1 mr-1' />
                            </td>
                            <td>
                              <button className="bg-[#5e7c93] text-white p-1 h-6 w-6 mt-1 flex items-center justify-center rounded-sm transition-opacity hover:opacity-80" onClick={(e) => delFeature(index)}>
                                <Minus size={20} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Release Notes</h3>
                <div className='px-4 reset mh-36'>
                  <span contentEditable="true" onInput={(e) => handleReleaseNotes(e.currentTarget.innerHTML)} dangerouslySetInnerHTML={{__html: appData.releaseNotes}} />
                </div>
                {releaseNotesChanged &&
                  <div className='p-1 float-right'>
                    <button className="bg-[#5e7c93] text-white p-1 h-6 w-6 flex items-center rounded-sm transition-opacity hover:opacity-80" onClick={(e) => postReleaseNotes()}>
                      <SaveIcon size={20} />
                    </button>
                  </div>
                }
              </div>
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">System requirements</h3>
                <div className="p-4">
                  <p className="text-sm mb-2">{appData.systemRequirements.text}</p>
                  <a href={appData.systemRequirements.link} className="text-sm text-blue-600 hover:underline">
                    Go to Official Website
                  </a>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Additional Information</h3>
                <div className="p-4">
                  <div className="text-sm">
                    <div className="grid grid-cols-2 gap-2 py-1 border-b border-gray-100">
                      <div className="flex items-start">
                        <div className="text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-500 text-xs font-light text-left pl-2">Developed by</p>
                          <input onBlur={(e) => handleCreatedBy(e.currentTarget.value)} defaultValue={appData.additionalInfo.creator} className="p-1 text-left pl-2 width-100" />
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                          </svg>
                        </div>
                        <div className='rel-date pl-2' >
                          <p className="text-gray-500 text-xs font-light text-left">Release Date</p>
                          <DatePicker selected={releaseDate} onChange={(date) => postCreationDate(date)} showMonthDropdown showYearDropdown dropdownMode="select" dateFormat="MMM. d, yyyy" />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 py-2 border-b border-gray-100">
                      <div className="flex items-start">
                        <div className="mr-2 text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <rect x="7" y="7" width="3" height="9"></rect>
                            <rect x="14" y="7" width="3" height="5"></rect>
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-500 text-xs font-light text-left">Category</p>
                          <Select 
                          options={categoryOptions} 
                          value={selectedCategory} 
                          onChange={handleCategorySelect} 
                          placeholder="--" 
                          styles={categorySelect}
                          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} />
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="mr-2 text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-500 text-xs font-light text-left">Download Size</p>
                          <p className="font-medium text-left">{appData.additionalInfo.filesize}</p>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 py-2 border-b-0">
                      <div className="flex items-start">
                        <div className="mr-2 text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-500 text-xs font-light text-left">Languages</p>
                          <p className="font-medium text-left">{appData.additionalInfo.language}</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="mr-2 text-gray-400 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-500 text-xs font-light text-left">Release Version</p>
                          <p className="font-medium text-left">{appData.additionalInfo.version}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1D5176]">
                <h3 className="bg-[#1D5176] text-white px-4 py-2 font-medium">Related resources</h3>
                <div className="p-4">
                  <div className="space-y-1">
                    {appData.relatedResources.map((resource: {name: string, link?: string}, index: number) => (
                      resource.link ? (
                          <div key={index} className="flex justify-between items-center text-sm py-2 border-b border-gray-100 last:border-b-0">
                              <Link to={resource.link} rel="noopener noreferrer">
                                <span>{resource.name}</span>
                              </Link>
                              <Link to={resource.link} rel="noopener noreferrer">
                                <ChevronRight className="h-5 w-5 text-gray-400" />
                              </Link>
                          </div>
                        ) : (
                          <div key={index} className="flex justify-between items-center text-sm py-2 border-b border-gray-100 last:border-b-0">
                              <span>{resource.name}</span>
                          </div>
                        )
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppCenter;